const KqHomePage = {
  path: "/index",
  name: "keqiHomePage",
  meta: {
      noCheckLogin: true
    },
    component: () => import("@/pages/keqi/homePage")
};
const introduce = {
  path: "/introduce",
  name: "keqiIntroduce",
  meta: {
    noCheckLogin: true
  },
  component: () => import("@/pages/keqi/introduce")
};
const Ticket = {
  path: "/ticketlist",
  name: "keqiTicketList",
  meta: {
    noCheckLogin: true
  },
  component: () => import("@/pages/ticket/ticketlist")
};
const eatery = {
  path: "/eaterylist",
  name: "keqiEateryList",
  meta: {
    noCheckLogin: true
  },
  component: () => import("@/pages/eatery/eaterylist")
};
const shop = {
  path: "/shoplist",
  name: "keqiShopList",
  meta: {
    noCheckLogin: true
  },
  component: () => import("@/pages/shop/shoplist")
};
const hotel = {
  path: "/hotellist",
  name: "keqiHotelList",
  meta: {
    noCheckLogin: true
  },
  component: () => import("@/pages/hotel/hotellist")
};

const keqiRouter = [
  KqHomePage,
  introduce,
  Ticket,
  eatery,
  shop,
  hotel,
];

export default keqiRouter;


// WEBPACK FOOTER //
// ./src/router/keqi.js